import { Box, CircularProgress, LinearProgress } from '@mui/material';
import type { FC, JSX } from 'react';

type TContentLoaderProps = {
  variant?: 'circular' | 'linear';
  minHeight?: string;
};

export const ContentLoader: FC<TContentLoaderProps> = ({ variant = 'circular', minHeight = '50vh' }): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight={minHeight} width="100%">
    {variant === 'circular' ? <CircularProgress /> : <LinearProgress sx={{ width: '100%', maxWidth: 400 }} />}
  </Box>
);
